import { useState, useEffect, useRef } from 'react'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { isEmpty, some } from 'lodash-es'

import { useLoginData } from 'utils/api/hooks'
import { GtmAgent } from 'utils/hooks/analytics'
import Avatar from 'components/common/Avatar'

const DynamicPopperMenu = dynamic(() => import('./PopperMenu'), { ssr: false })

const MenuListC = ({ isLarge, greeting }) => {
  const { loggedIn, me } = useLoginData()
  const [isProfileComplete, setIsProfileComplete] = useState(false)

  useEffect(() => {
    if (me) {
      const isProfileFilledUp = !some(
        [
          me.fullname,
          me.email,
          me.birthday,
          me.contactAddress?.county,
          me.contactAddress?.district,
          me.contactAddress?.details,
        ],
        isEmpty
      )

      const isGenderFilledUp = ['女性', '男性', '不願透露'].includes(me.gender)
      const isComplete = isProfileFilledUp && isGenderFilledUp

      setIsProfileComplete(isComplete)
    }
  }, [me])

  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('lg'))

  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)

  const handleToggle = () => {
    if (!isSmall) return
    if (!open) {
      GtmAgent.directSendToGTM({
        event: 'living_action',
        living_event_name: 'membermenu_imp',
      })
    }
    setOpen((prevOpen) => !prevOpen)
  }

  return (
    <Box display="flex">
      <div>
        <Box
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          pl={loggedIn ? 1.5 : 3}
          py={loggedIn ? 2.5 : 4}
          onClick={handleToggle}
          onMouseEnter={() => {
            if (!isSmall) {
              GtmAgent.directSendToGTM({
                event: 'living_action',
                living_event_name: 'membermenu_imp',
              })
              setOpen(true)
            }
          }}
          onMouseLeave={() => (!isSmall ? setOpen(false) : '')}
        >
          {loggedIn ? (
            <Box position="relative">
              <Avatar
                sx={{ width: 36, height: 36 }}
                style={{ cursor: 'pointer' }}
              />
              {!isProfileComplete && (
                <Box
                  position="absolute"
                  top={0}
                  right={0}
                  border="1px solid white"
                  borderRadius="50%"
                  width={8}
                  height={8}
                  bgcolor="red"
                />
              )}
            </Box>
          ) : (
            <>
              <Box display="flex">
                <Image
                  src="/img/user.svg"
                  width="24"
                  height="24"
                  style={{ cursor: 'pointer' }}
                  alt=""
                />
              </Box>
            </>
          )}

          <DynamicPopperMenu
            isSmall={isSmall}
            greeting={greeting}
            open={open}
            onClose={() => setOpen(false)}
            iconRef={anchorRef.current}
          />
        </Box>
      </div>
    </Box>
  )
}

export default MenuListC
